import { observer } from 'mobx-react-lite';

import { useStore } from 'src/store';

import { ColumnTab } from './entities/column-tab.entity';
import type { FormStore } from './entities/form.entity';
import { GeologicalLoadTab } from './geological-load-tab';
import { RigOperationsTab } from './rig-operations-tab';
import type { TSplitApproachOptions } from './types';
import { WellFormColumn } from './well-form-column';
import styles from './well-form-component.module.scss';

type Props = {
  formStore: FormStore;
  onAddWellToChart(): void;
  onSplitApproach?({ sectionId, stage, approach }: TSplitApproachOptions): void;
  onAddNewApproach?(): void;
};

export const WellFormComponent = observer(function WellFormComponent({
  formStore,
  onAddWellToChart,
  onSplitApproach,
  onAddNewApproach,
}: Props) {
  const { directories } = useStore();

  if (directories.isLoading || !formStore.isPluginsInitialized) return null;

  // if (formStore.activeTabId === 'stages') {
  //   return (
  //     <WellFormApproachesTab
  //       formStore={formStore}
  //       onAddWellToChart={onAddWellToChart}
  //       onSplitApproach={onSplitApproach}
  //       onAddNewApproach={onAddNewApproach}
  //     />
  //   );
  // }

  if (formStore.activeTabId === 'geologicalLoad') {
    return <GeologicalLoadTab formStore={formStore} directories={directories} />;
  }

  if (formStore.activeTabId === 'rigOperations') {
    return <RigOperationsTab formStore={formStore} directories={directories} onAddWellToChart={onAddWellToChart} />;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.columnsWrapper}>
        {formStore.activeTab instanceof ColumnTab &&
          formStore.activeTab.columns.map((column) => (
            <WellFormColumn key={column.id} items={column.items} formStore={formStore} />
          ))}
      </div>
    </div>
  );
});
